<template>
  <div class="container-fluid m-4">
    <div class="row justify-content-center">
      <h1 class="col-12 text-center font-weight-bold">404</h1>
      <h2  class="col-12 text-center text-muted">صفحه غير موجوده</h2>
      <h6 class="col-12 text-muted text-center">يبدو انك طلبت صفحه غير موجوده</h6>
    </div>
  </div>
</template>

<script>
export default {
name: "NotFound"
}
</script>

<style scoped>
  h1{
    font-size: 150px;
  }
</style>